import { getToken, setTokenAccess } from 'api/utils/tokenManagement';

import { ERROR_LEVELS, SENTRY_AXIOS } from 'services/Sentry/constants';
import { Platform } from 'constants/api';

import sentry from 'services/Sentry/SentryInstance';
import { initApiClient } from 'services/api/ApiClientService';

const MAX_RETRIES = 3;

const ApiClientMobile = () => {
    return initApiClient({
        apiUrl: import.meta.env.MOBILE_API_URL,
        apiVersion: import.meta.env.MOBILE_API_VERSION,
        apiKey: import.meta.env.MOBILE_API_KEY,
        retries: MAX_RETRIES,
        timeout: 35000,
        headers: { platform: String(Platform.Web), ['client-version']: '1.0.0' },
        headerTokenKey: 'auth-token',
        getAuthToken: () => getToken(),
        onUpdateToken: (token) => setTokenAccess(token),
        onErrorHandler: ({ extras, status, message }) => {
            if (typeof extras?.requestURL === 'string') {
                const isSendAccessCode = extras?.requestURL.includes('auth/send-access-code');

                if (Number(status) === 404 && isSendAccessCode) return;
            }

            const level = Number(status) >= 500 ? ERROR_LEVELS.CRITICAL : ERROR_LEVELS.ERROR;

            sentry.logError(new Error(message), SENTRY_AXIOS, level, extras);
        },
    });
};

export default ApiClientMobile();
